import InnerComponent from '@Components/Production/ManufacturingOrders';
import orgContainer from '@Components/AppContainer';

const ListManufacturingOrders = () => ((orgContainer(InnerComponent)));
export default ListManufacturingOrders;
